import styled from 'styled-components'
import { Heading, Paragraph } from '../../atoms/Typography/Typography.styles'
import { Icon } from '../../atoms/Icon/Icon.styles'
import { Tag } from '../../atoms/Tag/Tag.styles'

interface BentoBoxCaseElementProps {
  colorScheme?: string
}

export const BentoBoxCaseElement = styled.a<BentoBoxCaseElementProps>`
  text-decoration: none;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  border-radius: ${({ theme }) => theme.rem(16)};
  overflow: hidden;
  background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`]?.surface?.inside || 'transparent'};

  ${Paragraph},
  ${Heading} {
    color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`]?.surface?.text?.base?.primary || 'black'}!important;
  }

  ${Tag} {
    background-color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`]?.surface?.tags?.background || 'transparent'};

    > ${Icon}, ${Paragraph} {
      color: ${({ theme, colorScheme }) => theme.colorScheme[`${colorScheme}`]?.surface?.tags?.text || 'black'}!important;
    }
  }
`

export const BentoBoxCaseElementContent = styled.div<BentoBoxCaseElementProps>`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  gap: ${({ theme }) => theme.rem(12)};
  align-items: flex-start;
  padding: ${({ theme }) => theme.rem(24)};
  min-height: ${({ theme }) => theme.rem(380)};

  ${({ theme }) => theme.mediaQuery.md(`
    padding: ${theme.rem(40)};
  `)}
`

export const BentoBoxCaseElementUpperContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(12)};
`

export const BentoBoxCaseElementTags = styled.div`
  width: 100%;
`

export const BentoBoxCaseElementTexts = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.rem(12)};
`

export const BentoBoxCaseElementImage = styled.div`
  width: 100%;
  height: ${({ theme }) => theme.rem(260)};
  overflow: hidden;
  position: relative;
  cursor: none;
  flex-shrink: 0;

  img {
    object-fit: cover;
    object-position: center;
  }
`

